module.exports = __webpack_public_path__ + "static/media/BANNER-CONTATOS-MOBILE.f00107d3.jpg";